import { map, prop } from "ramda";
import { getChangeObjByAnchor } from "@/utils/muutokset";

export const getReducedStructureIncludingChanges = (
  baseAnchor,
  reducedStructure = [],
  changeObjects
) => {
  return map(component => {
    const anchor = `${baseAnchor}.${component.fullAnchor}`;
    const changeObj = getChangeObjByAnchor(anchor, changeObjects);
    return {
      anchor,
      properties: Object.assign(
        {},
        component.properties,
        prop("properties", changeObj) || {}
      )
    };
  }, reducedStructure);
};
